import { useEffect, useRef, type ReactNode } from 'react'

/** A native <dialog> driven by `open`. Escape and the close button call `onClose`. */
export function Modal({ open, title, onClose, children, wide = false }: { open: boolean; title: string; onClose: () => void; children: ReactNode; wide?: boolean }) {
  const ref = useRef<HTMLDialogElement>(null)
  useEffect(() => {
    const dialog = ref.current
    if (!dialog) return
    if (open && !dialog.open) dialog.showModal()
    else if (!open && dialog.open) dialog.close()
  }, [open])
  return (
    <dialog ref={ref} className={`dialog${wide ? ' dialog-wide' : ''}`} aria-label={title} onClose={onClose}>
      <div className="dialog-head">
        <h2>{title}</h2>
        <button type="button" className="icon-btn" aria-label="Close" onClick={onClose}>×</button>
      </div>
      {open && children}
    </dialog>
  )
}
